import { render, staticRenderFns } from "./purchase-statistics.vue?vue&type=template&id=2104ac6e&scoped=true"
import script from "./purchase-statistics.vue?vue&type=script&lang=js"
export * from "./purchase-statistics.vue?vue&type=script&lang=js"
import style0 from "./purchase-statistics.vue?vue&type=style&index=0&id=2104ac6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2104ac6e",
  null
  
)

export default component.exports